import axios from 'axios';
import { store } from '../store';

export function loadEnrollments(params = { }) {
  const state = store.getState();
  const { token } = state.auth;
  const {
    sortTerm,
    sortInverse,
    submitDateStart,
    submitDateEnd,
    submitted,
    // searchTerm,
    page,
    pageSize,
  } = state.enrollments;

  const {
    agentUsername = '',
    shopperUsername = '',
  } = params;

  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/enrollment`,
      method: 'get',
      headers: { Authorization: `Token ${token}` },
      params: {
        agent_username: agentUsername,
        shopper_username: shopperUsername,
        submit_date_start: submitDateStart,
        submit_date_end: submitDateEnd,
        // Our querystring can't handle submitted=(true-or-false) - so only add it if set
        ...(submitted === 'false' || submitted === 'true'
          ? { submitted }
          : { }),
        ordering: `${sortInverse ? '-' : ''}${sortTerm}`,
        page,
        page_size: pageSize,
      },
    }).then(({ data = {} }) => {
      resolve(data);
    }).catch(err => {
      reject(err);
    });
  });
}

/* eslint-disable no-unneeded-ternary */
// Allow changing several fields (must also supply carrier-formatted fields in data) or cancel an enrollment
// * /user-admin/user-details/leads/enrollments/
export function updateEnrollment(params = {}) {
  const state = store.getState();
  const { token } = state.auth;
  const {
    quote_id,
    submitted = [],
    fields = {},
    cancelled = false,
  } = params;

  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/enrollment/${quote_id}/`,
      method: 'put',
      headers: { Authorization: `Token ${token}` },
      data: {
        fields,
        submitted,
        cancelled,
      },
    }).then(({ data = {} }) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  });
}
